import React, { useRef } from "react"
import Dialog from "../../../common/blocks/dialog/Dialog"
import Card from "../../../common/blocks/card/Card"
import Button from "../../../common/blocks/button/Button"
import Icon from "../../../common/blocks/icon/Icon"
import * as classNames from "./DialogApplicationForm.module.scss"

const DialogApplicationForm = () => {
  const hiddenFileInput = useRef(null)
  return (
    <Dialog>
      <div className="dialog_header">
        <div className="text-center pt-4 relative z-1">
          <h2 className="m-0 ternary-text-color">Déposer ma candidature</h2>
        </div>
      </div>
      <div className="dialog_main">
        <div className="p-4 relative z-1">
          <Card className="p-3 text-center">
            <p>
              Votre CV et/ou votre profil Linkedin complet seront transmis{" "}
              <br />
              en toute confidentialité à l’équipe de recrutement.
            </p>
            <div className="buttons mt-3 justify-content-center gap-3">
              <Button
                aspect="classique"
                size="large"
                color="primary"
                onClick={() => {
                  console.log("Postuler avec Linkedin")
                }}
              >
                <Icon
                  icon="linkedin"
                  color="primary"
                />
                Postuler avec Linkedin
              </Button>
              <Button
                aspect="classique"
                size="large"
                color="primary"
                onClick={() => {
                  console.log("Remplir avec mon CV")
                }}
              >
                <Icon
                  icon="facture"
                  color="primary"
                />
                Remplir avec mon CV
              </Button>
            </div>
          </Card>
          <form
            action="#"
            encType="multipart/form-data"
            method="POST"
            netlify-honeypot="bot-field"
            data-netlify="true"
            name="jobApplication"
            className="flex flex-direction-column gap-3"
          >
            <Card className="p-3 mt-2">
              <input
                type="hidden"
                id="hidden"
                name="hidden"
              />
              <div className="form-group row gap-3">
                <div className="form-control col">
                  <label htmlFor="prenom">
                    Prénom<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    id="prenom"
                    name="prenom"
                    placeholder="Sarah"
                    required
                  />
                </div>
                <div className="form-control col">
                  <label htmlFor="nom">
                    Nom<sup>*</sup>
                  </label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    placeholder="Croche"
                    required
                  />
                </div>
              </div>
              <div className="form-group row gap-3">
                <div className="form-control col">
                  <label htmlFor="email">
                    Mail<sup>*</sup>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="votre.mail@mail.fr"
                    pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"
                    autoComplete="username"
                    required
                  />
                </div>
                <div className="form-control col">
                  <label htmlFor="tel">
                    Téléphone<sup>*</sup>
                  </label>
                  <input
                    type="tel"
                    id="tel"
                    name="tel"
                    placeholder="06 01 02 03 04"
                    pattern="[0-9]{10}"
                    required
                  />
                </div>
              </div>
              <div className="form-control m-0">
                <input
                  type="file"
                  id="file"
                  name="file"
                  ref={hiddenFileInput}
                  className={classNames.inputFiles}
                  required
                />
                <label htmlFor="file">
                  <Icon
                    icon="plus"
                    width="15"
                    height="15"
                  />
                  &nbsp;
                  <u>
                    Importer mon CV<sup>*</sup>
                  </u>
                  &nbsp;
                  <span className="uploadedFile fs-14"></span>
                </label>
              </div>
            </Card>
            <div className="form-group flex">
              <div className="form-control m-0">
                <input
                  type="checkbox"
                  id="checkbox"
                  name="checkbox"
                  required
                />
                <label htmlFor="checkbox">Je suis un humain</label>
              </div>
              <div className="form-control m-0 ml-auto">
                * Informations obligatoires
              </div>
            </div>
            <div className="form-control m-0">
              <Button
                aspect="contrastant"
                color="primary"
                size="large"
                type="submit"
                className="fluid"
                disabled
              >
                Envoyer ma candidature
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  )
}

export default DialogApplicationForm
